import { createSlice } from '@reduxjs/toolkit'

export const formSlice = createSlice({
    name: "addForm",
    initialState: {
        qtdModulos: {
            aifisio: 0, aito: 0,
            despachos: 0,
            epi: 0, parametros: 0, emergencia: 0, prontuario: 0, outrosDados: 0, orientacoes: 0,
            psicossocial: 0, responsavelfisc: 0, responsaveltec: 0, profissionais: 0, servico: 0,
            estagios: 0, recursoestrutura: 0, situacoes: 0, naohabilitada: 0, assistencia: 0, nafs: 0,
            nasfmunicipio: 0, nasflegalidade: 0, idprofissional: 0, publicidade: 0, setoresilpis: 0,
            sanitizacao: 0, setorcomfisio: 0, emergencia: 0, uti: 0, uci: 0, ucin: 0, enfermaria: 0,
            transporte: 0, ambulatorio: 0, residencia: 0, atribuicoes: 0, terceirizados: 0, fiscalizadores: 0,

            toperfilassistencia: 0, torecursos: 0, toregistroprontuario: 0, toestagio: 0, topessoanaohabilitada: 0,
            tooutrosDados: 0, toorientacoes: 0, tocapspsicossocial: 0, toresponsavelfisc: 0, toserviconaunidade: 0,
            toprofissionaisnoestabelecimento: 0, toparametrosassistenciais: 0, torecursoest: 0, tonasfmodalidade: 0,
            tonasfmunicipio: 0, toepi: 0, touti: 0, toucin: 0, tooutrasunidades: 0, toenfermaria: 0, toambulatorio: 0,
            toresidencia: 0, toexposicao: 0, tointervencoes: 0, toidprofissional: 0, topublicidade: 0, cer: 0
        },
        modulos: {
            tipo: '',
            dadosIniciais: [{}],
            dadosEstabelecimento: [{}],
            fechado: [{}], dificuldades: [{}],
            aifisio: [], aito: [],
            despachos: [],
            epi: [], parametros: [], emergencia: [], prontuario: [], outrosDados: [], orientacoes: [],
            psicossocial: [], responsavelfisc: [], responsaveltec: [], profissionais: [], servico: [],
            estagios: [], recursoestrutura: [], situacoes: [], naohabilitada: [], assistencia: [], nafs: [],
            nasfmunicipio: [], nasflegalidade: [], idprofissional: [], publicidade: [], setoresilpis: [],
            sanitizacao: [], setorcomfisio: [], emergencia: [], uti: [], uci: [], ucin: [], enfermaria: [],
            transporte: [], ambulatorio: [], residencia: [], atribuicoes: [], cer: [], terceirizados: [], fiscalizadores: [{}],

            toperfilassistencia: [], torecursos: [], toregistroprontuario: [], toestagio: [], topessoanaohabilitada: [],
            tooutrosDados: [], toorientacoes: [], tocapspsicossocial: [], toresponsavelfisc: [], toserviconaunidade: [],
            toprofissionaisnoestabelecimento: [], toparametrosassistenciais: [], torecursoest: [], tonasfmodalidade: [],
            tonasfmunicipio: [], toepi: [], touti: [], toucin: [], tooutrasunidades: [], toenfermaria: [], toambulatorio: [],
            toresidencia: [], toexposicao: [], tointervencoes: [], toidprofissional: [], topublicidade: []
        },
        ficha: {},
        modo: ''
    },
    reducers: {
        addQtd: (state, action) => {
            const { name } = action.payload.e.target
            const { modulo } = action.payload
            if (name === "menos") {
                if (state.qtdModulos[modulo] > 0) {
                    state.qtdModulos[modulo] -= 1
                    state.modulos[modulo].pop()
                }
            }
            if (name === "mais") {
                state.qtdModulos[modulo] += 1
                state.modulos[modulo].push({})
            }
        },

        tipoTv: (state, action) => {
            const { value } = action.payload.e.target
            state.modulos.tipo = value
        },

        inputs: (state, action) => {
            const { name, value } = action.payload.e.target
            const { modulo, index, subModulo, indexSub } = action.payload
            if (subModulo) {
                if (!state.modulos[modulo][index][subModulo]) {
                    state.modulos[modulo][index][subModulo] = []
                    state.modulos[modulo][index][subModulo].push(value)
                } else {
                    state.modulos[modulo][index][subModulo][indexSub] = value
                }
            } else {
                state.modulos[modulo][index][name] = value
            }
            localStorage.setItem('safeData', JSON.stringify(state.modulos))
        },

        checks: (state, action) => {
            const { name, value } = action.payload.e.target
            const { modulo, index } = action.payload
            // console.log('name: ', name, 'value: ', value, 'modulo: ', modulo, 'index: ', index)
            if (!state.modulos[modulo][index][name]) {
                state.modulos[modulo][index][name] = []
                state.modulos[modulo][index][name].push(value)
            } else {
                let indexValue = state.modulos[modulo][index][name].indexOf(value)
                if (indexValue === -1) {
                    state.modulos[modulo][index][name].push(value)
                } else {
                    state.modulos[modulo][index][name].splice(indexValue, 1)
                }
            }
            localStorage.setItem('safeData', JSON.stringify(state.modulos))
        },

        ficha: (state, action) => {
            state.ficha = action.payload
            state.modulos = action.payload
            state.qtdModulos = action.payload.quantidades[0]
        },

        setModo: (state, action) => {
            state.modo = "view"
        },

        dadosIniciais: (state, action) => {
            const { name, value } = action.payload
            state.modulos.dadosIniciais[0][name] = value
        },

        dadosEstabelecimento: (state, action) => {
            state.modulos.dadosEstabelecimento[0] = action.payload
        },

        recuperar: (state, action) => {
            state.ficha = JSON.parse(action.payload)
            state.modulos = JSON.parse(action.payload)
        }
    }
})

export const { addQtd, inputs, checks, ficha, tipoTv, setModo,
    dadosIniciais, dadosEstabelecimento, recuperar } = formSlice.actions

export default formSlice.reducer